import { render, staticRenderFns } from "./FaqAccuracy.vue?vue&type=template&id=eb04dc02&"
import script from "./FaqAccuracy.vue?vue&type=script&lang=js&"
export * from "./FaqAccuracy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports